import { sortingToteIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const updateSortingTote = {
  name: "updateSortingTote" as const,
  input: z.object({
    id: sortingToteIdFormat.schema,
    name: z.string().trim().min(1),
  }),
  output: z.object({}),
};
